/* global Symbol */
import * as syncActionCreators from '../sync';
import { push } from 'react-router-redux';

import Promise from 'bluebird';
import _ from 'lodash';


export function getJobRequest(id, jobId, callback) {
  return simpleIsoFetch => dispatch => {
     return simpleIsoFetch.get({
        route: `/api/contacts/${id}/jobs/${jobId}`
    })
    .then((resp) => {
      if(callback && callback.success) {
        return callback.success(resp.body.data.items);
      }
      return resp.body.data.items;
    }, (err) => {
      if(callback && callback.error) {
        return callback.error(err);
      }
      return err;
    })
    .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
      return err;
    });
  };
}

export function getJobRequestById(jobId, callback) {
  return simpleIsoFetch => dispatch => {
   return simpleIsoFetch.get({
      route: `/api/jobs/${jobId}`
  })
  .then((resp) => {
    if(callback && callback.success)
      return callback.success(resp.body.data.items);
    return resp.body.data.items;
  }, (err) => {
    if(callback && callback.error)
      return callback.error(err)

    return err;
  })
    .catch(err => {

        if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
      return err;
    });
  };
}

export function deleteJobRequest(jobId, callback) {
  return simpleIsoFetch => dispatch => {
     return simpleIsoFetch.del({
        route: `/api/jobs/${jobId}`
    })
    .then((resp) => {
      if(callback && callback.success) {
        return callback.success(resp.body.status);
      }
      return resp.body.status;
    }, (err) => {
      if(callback && callback.error) {
        return callback.error(err);
      }
      return err;
    })
    .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
      return err;
    });
  };
}

export function getPublicJobRequest(jobId, hash, callback) {
  return simpleIsoFetch => dispatch => {
   return simpleIsoFetch.get({
      route: `/api/jobs/temp/${hash}/${jobId}`
  })
  .then((resp) => {
    if(callback && callback.success)
      return callback.success(resp.body.data.items);
    return resp.body.data.items;
  }, (err) => {
    if(callback && callback.error)
      return callback.error(err)

    return err;
  })
    .catch(err => {

        if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
      return err;
    });
  };
}

export function createJobRequest(id, body, callback) {
  return simpleIsoFetch => dispatch => {
   return simpleIsoFetch.post({
      route: `/api/contacts/${id}/jobs`,
    body
  })
  .then((resp) => {
    if(callback && callback.success)
      return callback.success(resp.body.data.items);

    return resp.body.data.items;
  }, (err) => {
    if(callback && callback.error)
      return callback.error(err)

    return err;
  })
    .catch(err => {
        if (!err || !~[400].indexOf(err.status)) {
          console.log(err);
        return err;
      }
    });
  };
}

export function updateJobRequest(id, body, callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.put({
      route: `/api/contacts/${id}/jobs/${body.id}`,
      body
  })
  .then((resp) => {
    if(callback && callback.success)
      return callback.success(resp.body.data.items);

    return resp.body.data.items;
  }, (err) => {
    if(callback && callback.error)
      return callback.error(err)

    return err;
  })
    .catch(err => {
        if (!err || !~[400].indexOf(err.status)) {
          console.log(err);
        return err;
      }
    });
  };
}

  export function authorizeJobRequest(id, jobId, callback) {
    return simpleIsoFetch => dispatch => {
      simpleIsoFetch.put({
        route: `/api/contacts/${id}/jobs/${jobId}/authorize`
    })
    .then((resp) => {
      callback.success(resp.body.data.items);
    }, (err) => {
        callback.error(err)
    })
      .catch(err => {

          if (!err || !~[400].indexOf(err.status)) {
          console.log(err);
        }
      });
    };

}
export function getClientJobRequestsList(id, callback) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.get({
        route: `/api/contacts/${id}/jobs`
      })
      .then((resp) => {
      callback.success(resp.body.data.items);
  }, (err) => {
      callback.error(err)
    })
  .catch(err => {

      if (!err || !~[400].indexOf(err.status)) {
      console.log(err);
    }
  });
  };
}

export function getCompanyJobRequestsList(id, callback) {
  return simpleIsoFetch => dispatch => {
   return  simpleIsoFetch.get({
        route: `/api/companies/${id}/jobs`
      })
      .then((resp) => {

      if(callback && callback.success) {
        return callback.success(resp.body.data.items);
      }

      return resp.body.data.items;

  }, (err) => {
      if(callback && callback.error) {
        callback.error(err);
      }
    })
  .catch(err => {

    if(callback && callback.error) {
      return callback.error(err);
    }

    if (!err || !~[400].indexOf(err.status)) {
      console.log(err);
    }

    return err;

    });
  };
}

export function updateContactJobRequests(contactId, body, allowedStatuses = [], callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.put({
      route: `/api/contacts/${contactId}/jobs`,
      body,
      query: {
        allowedStatuses,
      }
    })
    .then((results) => {
      callback.success(results);
    })
    .catch((err) => {
      callback.error(err);
    });
  };
}

export function deleteContactJobRequests(contactId, body, allowedStatuses = [], callback) {
  return simpleIsoFetch => dispatch => {
    return simpleIsoFetch.del(`/api/contacts/${contactId}/jobs`, {
      body,
      query: {
        allowedStatuses
      }
    })
  .then((results) => {
    callback.success(results);
  })
  .catch((err) => {
    callback.error(err);
  });
 };
}

export function getAllJobs(callback, skip = 0, terms = [], filters = {}, companyId = null) {
  return simpleIsoFetch => dispatch => {
    simpleIsoFetch.get({
      route: `/api/${companyId ? `companies/${companyId}/` : ''}jobs`,
      query: {
        terms,
        ...filters,
        skip,
      }
    })
    .then((resp) => {
      callback.success(resp.body.data.items);
    }, (err) => {
      callback.error(err)
    })
    .catch(err => {
      if (!err || !~[400].indexOf(err.status)) {
          console.log(err);
      }
    });
  };
}

export function getJobRequestPDF(jobId, callback) {
  return simpleIsoFetch => dispatch => {
   return simpleIsoFetch.get({
      route: `/api/jobs/${jobId}/pdf`
  })
  .then((resp) => {
    if(callback && callback.success)
      return callback.success(resp.body);
    return resp.body;
  }, (err) => {
    if(callback && callback.error)
      return callback.error(err)

    return err;
  })
    .catch(err => {

        if (!err || !~[400].indexOf(err.status)) {
        console.log(err);
      }
      return err;
    });
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/jobrequests.js